import { createContext, useContext } from 'react';

const WizardContext = createContext({});

const useWizardContext = () => useContext(WizardContext);

export { WizardContext, useWizardContext };
